import { Outlet } from 'react-router-dom';
import { SkipToContent } from '@/components/SkipToContent';
import { privateMeta } from '@/lib/seo/site';
import { useSeoHead } from '@/lib/seo/useSeoHead';

// AdminLoginPage uses a dedicated minimal layout per Spec V1.1 §5.7
// ("Fond ink plein, pas de header/footer public"). Public header and
// site-wide footer are intentionally absent — the page renders its own
// shell against the body background.
export function AdminLoginLayout() {
  useSeoHead(privateMeta('Admin sign in'));
  return (
    <div className="layout layout--admin-login">
      <SkipToContent />
      <main id="main-content" className="layout__main layout__main--centered" tabIndex={-1}>
        <Outlet />
      </main>
    </div>
  );
}
